import React, { useEffect, useState } from "react";
import { MdOutlineAnalytics } from "react-icons/md";
import secureLocalStorage from "react-secure-storage";
import { currentUser, DOCTOR_BOOKING_FLAG, getCurrentUserRole, ROLES_NAME } from "modules/utilities/utility";
import ProductDetails from "./ProductDetails";
import CreateTicketScreen from "../../CreateTicket/CreateTicketV2";
import { useCustomer } from "modules/dashboards/actionables/store";
import _ from "lodash";
import CmsAppButton from "modules/navbar/top/CmsAppButton";
import ProfileDropdown from "modules/navbar/top/ProfileDropdown";
import { ANALYTICS_EMAIL_WHITELIST } from "config";

const APPS_ROLES = [
  ROLES_NAME.SUPER_ADMIN,
  ROLES_NAME.ADMIN,
  ROLES_NAME.MAKER,
  ROLES_NAME.CHECKER,
  ROLES_NAME.PUBLISHER,
  ROLES_NAME.DOCTOR,
  ROLES_NAME.CLINIC_DOCTOR,
  ROLES_NAME.CONSULT_DOCTOR,
];

const isAnalyticsWhitelisted = () => {
  const email = secureLocalStorage.getItem("email");
  if (typeof email !== "string") return false;
  return ANALYTICS_EMAIL_WHITELIST.includes(email.toLowerCase());
};

const TopNavRightSideNavItem = () => {
  const { customerData, ticketData } = useCustomer();
  const [isLeadDetailsPage, setIsLeadDetailsPage] = useState(false);

  useEffect(() => {
    const pathArray = window.location.pathname.split("/");
    setIsLeadDetailsPage(_.get(pathArray, 1) === "lead-details");
  }, [window.location.pathname]);

  const showCms = APPS_ROLES.includes(getCurrentUserRole());
  const showAnalytics = isAnalyticsWhitelisted();
  const hideCreateTicket =
    ["doctor", "consult_doctor"].includes(currentUser) && !DOCTOR_BOOKING_FLAG;

  return (
    <div className="topbar__right">
      {showCms && <CmsAppButton label="CMS" destination="/cms/segments" />}
      {showAnalytics && (
        <CmsAppButton
          label="Analytics"
          destination="/analytics"
          icon={<MdOutlineAnalytics size={18} />}
          color="#13c2c2"
        />
      )}

      <ProductDetails />

      {!hideCreateTicket && (
        <CreateTicketScreen
          customerData={isLeadDetailsPage ? customerData : null}
          ticketData={ticketData}
        />
      )}

      <div className="topbar__divider" />

      <ProfileDropdown />
    </div>
  );
};

export default TopNavRightSideNavItem;
